import React from 'react';
import { selectCardinalPluralCzech } from '~/utils/Intl/selectCardinalPlural';

export function czechHideExcludedProductsLabel(count: number, calculation: string): string {
	const phrase = selectCardinalPluralCzech(count, [
		'produkt nevstupující',
		'produkty nevstupující',
		'produktů nevstupujících',
	]);
	return `Skrýt ${count} ${phrase} ${calculation}`;
}

export function CzechHideExcludedProductsTooltip() {
	return (
		<>
			<p className='leading-snug'>
				Produkty nevstupují do výpočtu odškrtnutím pole <strong>Use for calc.</strong>, a to manuálně nebo automaticky
				(v závislosti na informacích o produktu).
			</p>
			<p className='leading-snug'>
				Ve výchozím nastavení jsou automaticky odškrtnuty produkty z nereferenčních datových zdrojů, produkty
				nepovažované za dostupné dle metodiky SÚKL, produkty chybějící v aktuálních datasetech, produkty bez ceny a
				produkty s expirovanou validitou.
			</p>
		</>
	);
}
